import React, { useEffect, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import { useDispatch } from "react-redux";
import { Add, Close, Delete, Edit } from '@mui/icons-material';
import { Autocomplete, styled as muiStyled } from '@mui/material';
import Loading from "components/Loading";
import PageImagePicker from "components/AdminBooks/PageImagePicker";
import { Person } from '@mui/icons-material';
import VideoPicker from "components/AdminBooks/VideoPicker";
import styled from "styled-components";
import { Col, Row, Switch } from "antd";
import { DeleteModal } from "components/Dialog";
import { TagFilled } from "@ant-design/icons";
import { filter, find, get, has, map } from "lodash";
import { useOneWayTeacherVideo } from "store/1wayteachervideo/selectors";

import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
} from '@mui/material';

import {
  handleCreateHOneWayTeacherVideo,
  handleDeleteOnewayTeacherVideo,
  handleListOneWayTeacherVideo,
  handleUpdateAllRecord,
  handleUpdateOneWayTeacherVideo,
} from "store/1wayteachervideo/thunks";
import SentryWrap from 'components/Sentry';

const StyledFormControl = muiStyled(FormControl)(({ theme }) => ({
  minWidth: 120,
}));

const StyledSelect = muiStyled(Select)(({ theme }) => ({
  marginTop: '4px',
}));



const PAGE_CATEGORY = [
  "ANÉCDOTAS SERIES",
  "AP SPANISH LANGUAGE",
  "PROFICIENCY LEVELS",
  "LITERACY",
];

const ModalContent = styled.div`
  left: 50%;
  width: 70vw;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  @media only screen and (max-width: 600px) {
    width: 90%;
  }
`;
const ModalConfigArea = styled.div`
  min-height: 75vh;
  max-height: 90vh;
  overflow: auto;
  margin-top: 10px;
`;
const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
`;
const ImageContainer = styled.div`
  img {
    max-height: 100px;
  }
`;

const EditVideo = ({ editResourseModal, onCloseModal, item }) => {
  const [resourceVideo, setResourcesVideo] = useState({});
  const [poster, setPoster] = useState("");
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [tags, setTags] = useState("");
  const [video, setVideo] = useState("");
  const [loading, setloading] = useState(false);
  const [for_student, setfor_student] = useState(false);
  const [error, setError] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (item) {
      setResourcesVideo(item);
      setPoster(get(item, "poster", ""));
      setTitle(get(item, "title", ""));
      setVideo(get(item, "video", ""));
      setCategory(get(item, "category", ""));
      setTags(get(item, "tags", ""));
      setfor_student(get(item, "for_student", false));
      setError([]);
    } else {
    }
  }, [item]);
  const onCreateOrUpdate = async () => {
    let err = [];
    if (!video) {
      err.push({
        key: "video",
        message: "Video required!",
      });
    }
    if (!poster) {
      err.push({
        key: "poster",
        message: "Poster image required!",
      });
    }
    if (!title) {
      err.push({
        key: "title",
        message: "Title  required!",
      });
    }
    if (!category) {
      err.push({
        key: "category",
        message: "Category  required!",
      });
    }
    setError(err);
    if (err.length == 0) {
      setloading(true);
      if (has(item, "id")) {
        const data = {
          ...item,
          poster,
          video,
          title,
          category,
          tags,
          for_student,
        };
        await dispatch(handleUpdateOneWayTeacherVideo(data));
      } else {
        const data = {
          poster,
          video,
          title,
          category,
          tags,
          for_student,
        };
        await dispatch(handleCreateHOneWayTeacherVideo(data));
      }
      setloading(false);
      onCloseModal();
    }
  };
  return (
    <Modal
      open={editResourseModal}
      onClose={() => {}}
      style={{ height: "100%", width: "100%" }}
    >
      <ModalContent>
        <Row style={{ justifyContent: "space-between" }}>
          <TitleText>
            {has(item, "id") ? "Update Video" : "Add Video"}
          </TitleText>
          <IconButton onClick={onCloseModal} style={{ padding: 0 }}>
            <Close color="secondary" />
          </IconButton>
        </Row>
        <ModalConfigArea>
          <Row>
            <Col lg={12} xs={24}>
              <FormLabel style={{ color: "black" }} component="legend">
                Video
              </FormLabel>
              <VideoPicker
                src={video}
                onChange={(item) => {
                  setVideo(item.url);
                  setError(filter(error, (e) => e.key != "video"));
                }}
              />
            </Col>
            <Col lg={12} xs={24} style={{ paddingLeft: 10, paddingTop: 10 }}>
              <FormLabel style={{ color: "black" }} component="legend">
                Poster for videos:
              </FormLabel>
              <ImageContainer>
                <PageImagePicker
                  src={poster}
                  path={`/poster}`}
                  style={{ minHeight: 270, marginBottom: 24 }}
                  onChange={(item) => {
                    setPoster(item.url);
                    setError(filter(error, (e) => e.key != "poster"));
                  }}
                  hasDescription={false}
                />
              </ImageContainer>
              {has(item, "id") ? (
                <Row justify="start" style={{ marginBottom: 10 }}>
                  <TextField
                    id="id"
                    name="id"
                    label="Id"
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    disabled
                    variant="outlined"
                    value={get(resourceVideo, "id")}
                  />
                </Row>
              ) : null}
              <Row justify="start" style={{ marginBottom: 30 }}>
                <TextField
                  id="title"
                  name="title"
                  error={find(error, ["key", "title"])}
                  label="Title"
                  InputLabelProps={{ shrink: true, required: true }}
                  required
                  type="text"
                  variant="outlined"
                  onChange={(e) => {
                    setTitle(e.target.value);
                    setError(filter(error, (e) => e.key != "title"));
                  }}
                  value={title}
                />
              </Row>
              <Row justify="start" style={{ marginBottom: 20 }}>
                <Col xs={24} lg={24}>
                  <Autocomplete
                    multiple
                    freeSolo
                    id="tags-outlined"
                    options={[]}
                    defaultValue={
                      tags && tags.length > 0 ? tags.split(",") : []
                    }
                    style={{ width: "100%" }}
                    onChange={(event, value) => {
                      setTags(value.join(","));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        label="Tags"
                        placeholder="Tags"
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row justify="start" style={{ marginBottom: 10 }}>
                <Col xs={24} lg={24}>
                  <StyledFormControl variant="outlined">
                    <InputLabel id="Categorias">Categorias</InputLabel>
                    <StyledSelect
                      labelId="Categorias"
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      label="Categorias"
                    >
                      {PAGE_CATEGORY.map((item) => (
                        <MenuItem value={item} key={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </StyledSelect>
                    {find(error, { key: "category" }) && (
                      <FormHelperText error>
                        {get(find(error, { key: "category" }), "message")}
                      </FormHelperText>
                    )}
                  </StyledFormControl>
                </Col>
              </Row>
              <Row justify="start" style={{ marginBottom: 10 }}>
                <Col xs={24} lg={24}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>Available for student 1</span>{" "}
                    <Switch
                      size="small"
                      checked={for_student}
                      onChange={(v) => setfor_student(v)}
                      style={{ marginLeft: 8 }}
                    />
                  </div>
                </Col>
              </Row>
              {error.length > 0 ? (
                <Row
                  style={{
                    marginTop: 10,
                    marginRight: 0,
                    marginLeft: 0,
                    flexDirection: "column",
                    display: "flex",
                  }}
                >
                  {error.map((v) => (
                    <FormHelperText key={v.key} error>
                      * {get(v, "message")}
                    </FormHelperText>
                  ))}
                </Row>
              ) : null}
              <Row
                gutter={[24, 24]}
                style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}
              >
                <Button
                  disabled={loading}
                  fullWidth
                  onClick={onCreateOrUpdate}
                  variant="contained"
                  color="primary"
                >
                  {loading ? <Loading white size={15} /> : null}
                  {has(item, "id") ? "Update" : "Create"}{" "}
                </Button>
              </Row>
            </Col>
          </Row>
        </ModalConfigArea>
      </ModalContent>
    </Modal>
  );
};

// Drag and Drop Item Types
const ItemTypes = {
  VIDEO_CARD: "video_card",
};

// Draggable Video Card Component
const DraggableVideoCard = ({
  category,
  index,
  moveCard,
  handleEdit,
  onDelete,
  onDragEnd,
}) => {
  const [{ isDragging }, drag, preview] = useDrag({
    type: ItemTypes.VIDEO_CARD,
    item: { id: category.id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: (item, monitor) => {
      if (monitor.didDrop()) {
        onDragEnd();
      }
    },
  });

  const [, drop] = useDrop({
    accept: ItemTypes.VIDEO_CARD,
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveCard(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  // Combine drag and drop refs
  const ref = (node) => {
    drag(drop(node));
    preview(node);
  };

  return (
    <div
      ref={ref}
      className={`myCategoryList OneWayVideoCover ${
        isDragging ? "dragging" : ""
      }`}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "move",
        transition: "opacity 0.2s ease",
      }}
    >
      <div className="card-resource ShowDetailBnr">
        <div className="btnsGrpMain">
          <div className="btnsGrpTxt" style={{ justifyContent: "center" }}>
            <Button
              className="btnsTxtYellow"
              onClick={() => handleEdit(category)}
            >
              <Edit style={{ fontSize: 20, marginRight: 3 }} />
              Edit
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              variant="contained"
              color="secondary"
              onClick={() => onDelete(category)}
            >
              <Delete style={{ fontSize: 20, marginRight: 3 }} />
              Delete
            </Button>
          </div>
        </div>
        <img src={category.poster} alt="" />
      </div>
      <div className="categoryBtnTxt">
        <div className="onway-teacher-txt">{category.title}</div>
        <div className="btm1Category">
          <div className="persionIconImg">
            <Person className="iconClrChange" />
            <span>{"ONE WAY EDUCATION"}</span>
          </div>
          <div className="persionIconImg">
            <TagFilled className="iconFldChange" />
            <span> {category.tags}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

// Auto-detect touch device
const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};

export default function LearnScreen() {
  const videos = useOneWayTeacherVideo();
  const [loading, setLoading] = useState(false);
  const [deleteToggle, setDeleteToggle] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [orderedVideos, setOrderedVideos] = useState([]);
  const dispatch = useDispatch();
  const [videoModalInfo, setVideoModalInfo] = React.useState({
    open: false,
    item: null,
  });


  useEffect(() => {
    if (videos) {
      const sortedActivities = [...videos].sort((a, b) => {
        const seqA = parseInt(a.sequence_order) || 0;
        const seqB = parseInt(b.sequence_order) || 0;
        return seqA - seqB;
      });
      setOrderedVideos(sortedActivities);
    }
  }, [videos]);

  const fetchItem = async () => {
    await dispatch(handleListOneWayTeacherVideo());
  };

  useEffect(() => {
    fetchItem();
  }, []);

  const onAdd = () => {
    setVideoModalInfo({ open: true, item: {} });
  };

  const handleEdit = (item) => {
    setVideoModalInfo({ open: true, item: item });
  };

  const onDeleteItem = async () => {
    if (has(selectedItem, "id")) {
      setLoading(true);
      await dispatch(handleDeleteOnewayTeacherVideo(selectedItem.id));
      setLoading(false);
    }
    setSelectedItem(null);
    setDeleteToggle(false);
  };

  const handleDeleteClick = (category) => {
    setSelectedItem(category);
    setDeleteToggle(true);
  };

  const moveCard = (fromIndex, toIndex) => {
    setOrderedVideos((prevVideos) => {
      const result = [...prevVideos];
      const [movedItem] = result.splice(fromIndex, 1);
      result.splice(toIndex, 0, movedItem);

      const updatedActivities = result.map((activity, index) => ({
        ...activity,
        sequence_order: index + 1,
      }));

      return updatedActivities;
    });
  };

  const handleDragEnd = async () => {
    await dispatch(handleUpdateAllRecord(orderedVideos));
  };

  // Choose backend based on device type

  return (
    <SentryWrap>
      <EditVideo
        editResourseModal={videoModalInfo.open}
        item={videoModalInfo.item}
        onCloseModal={() => setVideoModalInfo({ open: false, item: null })}
      />
      <DeleteModal
        deleteToggle={deleteToggle}
        setDeleteToggle={setDeleteToggle}
        onDelete={onDeleteItem}
        message={`Are you sure you want to delete "${get(selectedItem, "title")}"?`}
        loading={loading}
      />
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: 24,
          marginBottom: 16,
        }}
      >
        <Button variant="contained" color="primary" onClick={onAdd}>
          <Add /> Add videos
        </Button>
      </div>
      <Row className="learnContentUpr" gutter={[25, 0]}>
        <Col xs={24} sm={24} md={24}>
          <div className="learnContent">
            <div className="myCategorys">
              {map(orderedVideos, (category, index) => (
                <DraggableVideoCard
                  key={category.id}
                  category={category}
                  index={index}
                  moveCard={moveCard}
                  handleEdit={handleEdit}
                  onDelete={handleDeleteClick}
                  onDragEnd={handleDragEnd}
                />
              ))}
            </div>
          </div>
        </Col>
      </Row>

      {/* Optional: Add visual feedback */}
      <style jsx>{`
        .dragging {
          transform: rotate(5deg);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        }
        .myCategoryList {
          transition: transform 0.2s ease;
        }
        .myCategoryList:hover {
          transform: translateY(-2px);
        }
      `}</style>
    </SentryWrap>
  );
}